/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { FileColumn } from '../utils/ColumnsFormatters/FileColumn';
import { ModalRechazoArchivo } from './ModalRechazoArchivo';
import { filesAPI } from 'src/api/modules/files';
import { useSelector } from 'react-redux';
import notice from 'src/common/components/Notice';
const TableStart = ({
	className,
	UpdateItemsRETe,
	columns = [],
	items = [],
	onClickEnviar,
	onclickDetalle,
	nameSesion,
}) => {
	const [openModal, setOpenModal] = useState(false);
	const [fileIndex, setFileIndex] = useState(null);
	const [dataModal, setDataModal] = useState({});
	const [itemsReTe, setItemsReTe] = useState(items);
	const { user } = useSelector((state) => state.auth);
	const systemLevelRole = user?.organos[0].nombrePerfil.toUpperCase();

	const _onArchivoClick = (data) => {
		setDataModal(data);
		setOpenModal(true);
	};

	const _onArchivoAceptar = (currentdataMinos, index, currenticon) => {
		let estatus = systemLevelRole === 'RESPONSABLE DE SEGUIMIENTO' ? 'APO' : 'A';

		filesAPI
			.changeEstatus(currentdataMinos.id, estatus)
			.then((response) => {
				let nuewItems = [...itemsReTe];
				items[index].dataMinos[currenticon].estatus = estatus;
				if (UpdateItemsRETe) UpdateItemsRETe(nuewItems);
				notice('Archivo aceptado correctamente', 'success');
			})
			.catch((err) => notice('Ocurrio un error al aceptar ek archivo', 'error'));
	};
	const _onclickDetalle = (e) => {
		if (onclickDetalle) onclickDetalle(e.id, e.tipo);
	};

	const _onClickEnviar = (e) => {
		if (onClickEnviar)
			onClickEnviar(
				e.id,
				systemLevelRole,
				user.nombre + ' ' + user.apellidoPaterno,
				e.tipo
			);
	};

	const onUpload = (item, index) => {
		setFileIndex(index);
		const oficio = items[index].dataMinos.find((x) => x.tipo === 'O');
		const tarjeta = items[index].dataMinos.find((x) => x.tipo === 'T');
		const presentacion = items[index].dataMinos.find((x) => x.tipo === 'P');
		const adicional = items[index].dataMinos.find((x) => x.tipo === 'A');
		oficio.upload = oficio.upload == true ? oficio.upload : item.tipo == 'O';
		tarjeta.upload = tarjeta.upload == true ? tarjeta.upload : item.tipo == 'T';
		presentacion.upload =
			presentacion.upload == true ? presentacion.upload : item.tipo == 'P';
		adicional.upload = adicional.upload == true ? adicional.upload : item.tipo == 'A';
		let isSendDisabled = oficio.id == '' ? oficio.upload != true : false;

		if (!isSendDisabled) {
			isSendDisabled = tarjeta.upload || presentacion.upload ? true : false;
			if (isSendDisabled)
				isSendDisabled = tarjeta.upload && presentacion.upload ? false : true;
		}

		items[index].dataMinos = [oficio, tarjeta, presentacion, adicional];
		items[index].dataMinos[0].isSendDisabled = isSendDisabled;
		setItemsReTe([...items]);
	};
	useEffect(() => {
		if (fileIndex !== null) {
			UpdateItemsRETe();
		}
	}, [itemsReTe]);

	const onGetStatus = (data) => {
		switch (systemLevelRole.toUpperCase()) {
			case 'ENLACE':
				if (
					data.dataMinos.some(
						(item) => item.estatus === 'R' || item.estatus === 'RR'
					)
				) {
					return true;
				} else {
					return data.enviadoEnlace;
				}
			case 'RESPONSABLE DE SEGUIMIENTO':
				if (
					data.dataMinos.some(
						(item) => item.estatus === 'R' || item.estatus === 'RR'
					)
				) {
					return true;
				} else {
					return data.enviadoRS;
				}
			case 'RESPONSABLE DE ORGANO COLEGIADO':
				if (
					data.dataMinos.some(
						(item) => item.estatus === 'R' || item.estatus === 'RR'
					)
				) {
					return true;
				} else {
					return data.enviadoRO;
				}
			default:
				break;
		}
	};

	return (
		<>
			<ModalRechazoArchivo
				setOpen={setOpenModal}
				open={openModal}
				data={{
					id_archivo: dataModal.id,
					archivo: dataModal.title,
					resolucion: dataModal.resolucion,
					id_organo: Number(dataModal.organo),
				}}
				updateView={UpdateItemsRETe}
			/>
			<table class="table table-head-custom table-vertical-center border border-top">
				<thead>
					<tr>
						{columns.map((data) => (
							<th
								className={className}
								style={{
									width: data.width,
									textTransform: 'uppercase !important',
								}}
							>
								{data.text}
							</th>
						))}
					</tr>
				</thead>
				<tbody>
					{itemsReTe.map((data, index) => (
						<tr>
							<td class="text-center">{data.tipo}</td>
							<td class="text-center">{data.numeroResolucion}</td>
							<td class="text-center">{data.comite}</td>
							<td class="text-center">{data.fundamentoJuridico}</td>
							<td class="text-center">
								<FileColumn
									onUpload={onUpload}
									onClickAcept={_onArchivoAceptar}
									onClickrechazar={_onArchivoClick}
									row={data}
									rowIndex={index}
									currentIcon="0"
									nameSesion={nameSesion}
									btnFlag={onGetStatus(data)}
								/>
							</td>
							<td class="text-center">
								<FileColumn
									onUpload={onUpload}
									onClickAcept={_onArchivoAceptar}
									onClickrechazar={_onArchivoClick}
									row={data}
									rowIndex={index}
									currentIcon="1"
									nameSesion={nameSesion}
									btnFlag={onGetStatus(data)}
								/>
							</td>
							<td class="text-center">
								<FileColumn
									onUpload={onUpload}
									onClickAcept={_onArchivoAceptar}
									onClickrechazar={_onArchivoClick}
									row={data}
									rowIndex={index}
									currentIcon="2"
									nameSesion={nameSesion}
									btnFlag={onGetStatus(data)}
								/>
							</td>
							<td class="text-center">
								<FileColumn
									onUpload={onUpload}
									onClickAcept={_onArchivoAceptar}
									onClickrechazar={_onArchivoClick}
									row={data}
									rowIndex={index}
									currentIcon="3"
									nameSesion={nameSesion}
									btnFlag={onGetStatus(data)}
								/>
							</td>

							<td class="text-center">
								<Button
									onClick={() => _onclickDetalle(data)}
									className="btn btn-primary"
								>
									Detalle
								</Button>
							</td>
							<td class="text-center">
								<Button
									disabled={
										data.dataMinos[0].isSendDisabled ||
										onGetStatus(data)
									}
									onClick={() => _onClickEnviar(data)}
									className="btn btn-primary"
								>
									Enviar
								</Button>
							</td>
						</tr>
					))}
				</tbody>
			</table>
		</>
	);
};

export default TableStart;
